<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import VueBootstrapAutocomplete from '@vue-bootstrap-components/vue-bootstrap-autocomplete'

export default {
  page: {
    title: "Grupe",
  },
  components: {PageHeader, Layout, VueBootstrapAutocomplete},
  props: {
  },
  data() {
    return {
      title: 'Grupe',
      fields: [
        {key: 'name', label: 'Naziv', sortable: false},
        {key: 'types', label: 'Vrste', sortable: false},
        {key: 'budget', label: 'Budžet', sortable: false},
      ],
      administrators: [],
      selectedAdministrator: null,
      administratorQuery: '',
      groups: [],
      search: ''
    }
  },
  watch: {
    administratorQuery(v) {
      if (!this.administrators.find(e => e.company_name === v)) {
        this.selectedAdministrator = null;
      }
    },
    async selectedAdministrator(v) {
      if (!v) return;
      this.$store.commit('loader/START_LOADING');

      try {
        const {data} = await axios.get(`/super-admin/groups/${v.id}`);
        this.groups = data;
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }

    }
  },
  computed: {
    searchedGroups () {
      return this.groups.filter((g) => {
        return g.name?.toLowerCase().includes(this.search.toLowerCase())
      })
    },
  },
  async created() {
    this.$store.commit('loader/START_LOADING');

    try {
      const {data} = await axios.get('/super-admin/administrators');
      this.administrators = data;

    } catch (e) {
      // eslint-disable-next-line no-empty
    } finally {
      this.$store.commit('loader/END_LOADING');
    }
  },
  methods: {
    showGroup(group) {
      this.$router.push(`/super-admin/groups/${group.id}/edit`)
    },
    createNewGroup() {
      this.$router.push(`/super-admin/groups/create`)
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row mb-2">
      <div class="col-12 col-sm-6 d-flex">
        <label class="col-form-label mr-2" for="administrator">Firma:</label>
        <VueBootstrapAutocomplete
          class="autocomplete"
          id="administrator"
          :data="administrators"
          v-model="administratorQuery"
          :serializer="(item) => item.company_name"
          :minMatchingChars="0"
          showOnFocus
          @hit="selectedAdministrator = $event"
        />
      </div>
      <div class="col-12 col-sm-6 d-flex align-items-end justify-content-end">
        <b-button @click="createNewGroup" variant="primary">Nova grupa</b-button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="search-box chat-search-box mb-2">
          <div class="position-relative">
            <input v-model="search" type="text" class="form-control" placeholder="Pretraži..."/>
            <i class="bx bx-search-alt search-icon"></i>
            <i class="bx bx-x clear-icon" @click="search = ''"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <b-table :items="searchedGroups" :fields="fields" striped responsive
                 class="border-left border-right border-bottom"
                 selectable
                 @row-clicked="showGroup"
        >
          <template v-slot:cell(types)="data">
            {{ data.value.map(t => t.name).join(", ") }}              
          </template>
        </b-table>

      </div>
    </div>
  </Layout>
</template>

<style scoped>
  .search-box .form-control {
    border-radius: 0.25rem;
  }
  .autocomplete {
    width: 100%;
  }
</style>
